import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { ListOption } from '../modules/tcm-core.module';
import { ListOptionRequest } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class VendorDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getVendorOptionsAsync(query: string, timeout?: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('vendors/options', request, timeout);
  }

  public checkVendorCodeExists(id: number, code: any, timeout: Promise<any>): Promise<boolean> {
    const request = { id: id, code: code };
    return this.httpClient.getJsonAsync('Vendors/CheckVendorCodeExists', request, timeout);
  }
}
